module.exports = __webpack_public_path__ + "img/Atlas Copco.0af87600.jpg";